import { useNavigate } from 'react-router-dom'
import type { BackProps } from './index.type'
import Ripple from '@/components/Ripple'

export default function Back({ onClick }: BackProps) {
    const navigate = useNavigate()

    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            navigate(-1)
        }
    }

    return (
        <Ripple className='rounded-full'>
            <div
                onClick={handleClick}
                className="flex items-center justify-center w-7.5 h-7.5 bg-white border-[0.5px] border-solid border-[#0B0B0B]/12  rounded-full"
            >
                <img className="w-3" src="/icon/back.svg" />
            </div>
        </Ripple>
    )
}